import React from 'react';
import PropTypes from 'prop-types';
import { Panel } from 'react-bootstrap';

import { colours, scenarios } from './../helpers';
import PieChartComponent from './PieChartComponent';

const pieSlices = scenarios.getPieSlices(scenarios.SCENARIO_IMPORTANCE, colours.colours);

const PieStatsComponent = ({
  style,
  title,
  pieData,
  link
}) => (
  <div>
    <Panel bsStyle={style}>
      <Panel.Heading>
        <Panel.Title>
          <div>
            {title}
            {link ? <a href={link} style={{ float: 'right' }}>Link</a> : null}
          </div>
        </Panel.Title>
      </Panel.Heading>
      <PieChartComponent height={100} slices={pieSlices} data={pieData} />
    </Panel>
  </div>
);

PieStatsComponent.propTypes = {
  style: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  pieData: PropTypes.arrayOf(PropTypes.number).isRequired,
  link: PropTypes.string
};

export default PieStatsComponent;


// WEBPACK FOOTER //
// src/Components/PieStatsComponent.jsx